import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const API = `${process.env.REACT_APP_API_URL}/api`;

type Adim = 'secim' | 'email' | 'kod';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [adim, setAdim] = useState<Adim>('secim');
  const [email, setEmail] = useState('');
  const [kod, setKod] = useState(['', '', '', '', '', '']);
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);
  const [geriSayim, setGeriSayim] = useState(0);
  const kodRefs = useRef<(HTMLInputElement | null)[]>([]);

  const handleGoogleLogin = () => {
    window.location.href = `${API}/auth/google`;
  };

  const geriSayimBaslat = () => {
    setGeriSayim(60);
    const t = setInterval(() => {
      setGeriSayim(s => {
        if (s <= 1) { clearInterval(t); return 0; }
        return s - 1;
      });
    }, 1000);
  };

  const otpGonder = async (e?: React.FormEvent) => {
    e?.preventDefault();
    if (!email.trim()) return setHata('E-posta girin');
    setHata('');
    setYukleniyor(true);
    try {
      const r = await fetch(`${API}/auth/otp-gonder`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      const veri = await r.json();
      if (!r.ok) return setHata(veri.hata || 'Gönderilemedi');
      setAdim('kod');
      geriSayimBaslat();
      setTimeout(() => kodRefs.current[0]?.focus(), 100);
    } catch {
      setHata('Sunucuya bağlanılamadı');
    } finally {
      setYukleniyor(false);
    }
  };

  const kodGuncelle = (index: number, deger: string) => {
    if (!/^\d?$/.test(deger)) return;
    const yeni = [...kod];
    yeni[index] = deger;
    setKod(yeni);
    if (deger && index < 5) kodRefs.current[index + 1]?.focus();
    if (yeni.every(k => k) && deger) {
      dogrula(yeni.join(''));
    }
  };

  const kodKeyDown = (index: number, e: React.KeyboardEvent) => {
    if (e.key === 'Backspace' && !kod[index] && index > 0) {
      kodRefs.current[index - 1]?.focus();
    }
  };

  const dogrula = async (tamKod?: string) => {
    const girilenKod = tamKod || kod.join('');
    if (girilenKod.length < 6) return setHata('6 haneli kodu girin');
    setHata('');
    setYukleniyor(true);
    try {
      const r = await fetch(`${API}/auth/otp-dogrula`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), kod: girilenKod }),
      });
      const veri = await r.json();
      if (!r.ok) {
        setHata(veri.hata || 'Doğrulanamadı');
        setKod(['', '', '', '', '', '']);
        setTimeout(() => kodRefs.current[0]?.focus(), 50);
        return;
      }
      window.location.href = `/auth/callback?token=${veri.token}&rol=${veri.rol}`;
    } catch {
      setHata('Sunucuya bağlanılamadı');
    } finally {
      setYukleniyor(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#f5f5f5', fontFamily: 'sans-serif'
    }}>
      <div style={{
        background: 'white', borderRadius: 12, padding: '48px 40px',
        boxShadow: '0 2px 16px rgba(0,0,0,0.08)', textAlign: 'center', width: 360
      }}>
        <div style={{ fontSize: 32, fontWeight: 700, marginBottom: 8, letterSpacing: -1 }}>
          istanbulTANGO
        </div>
        <div style={{ color: '#888', fontSize: 14, marginBottom: adim === 'secim' ? 8 : 36 }}>
          {adim === 'secim' && 'Yönetim paneli'}
          {adim === 'email' && 'E-posta ile giriş'}
          {adim === 'kod' && `${email} adresine kod gönderdik`}
        </div>

        {adim === 'secim' && (
          <div style={{ fontSize: 13, color: '#aaa', marginBottom: 24, lineHeight: 1.6 }}>
            İstanbul Tango dans okulu yönetim sistemi. Öğrenci kayıtları, ders programı, yoklama ve ödeme takibi.
          </div>
        )}

        {/* Adım: Seçim */}
        {adim === 'secim' && (
          <>
            <button
              onClick={handleGoogleLogin}
              style={{
                width: '100%', padding: '12px 20px', borderRadius: 8,
                border: '1px solid #ddd', background: 'white', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                gap: 10, fontSize: 14, fontWeight: 500, color: '#333', marginBottom: 12,
              }}
            >
              <svg width="18" height="18" viewBox="0 0 18 18">
                <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z"/>
                <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17z"/>
                <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18l2.67-2.07z"/>
                <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.31z"/>
              </svg>
              Google ile giriş yap
            </button>

            <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '16px 0' }}>
              <div style={{ flex: 1, height: 1, background: '#eee' }} />
              <span style={{ fontSize: 12, color: '#aaa' }}>veya</span>
              <div style={{ flex: 1, height: 1, background: '#eee' }} />
            </div>

            <button
              onClick={() => { setAdim('email'); setHata(''); }}
              style={{
                width: '100%', padding: '12px 20px', borderRadius: 8,
                border: '1px solid #ddd', background: 'white', cursor: 'pointer',
                fontSize: 14, fontWeight: 500, color: '#333',
              }}
            >
              ✉ E-posta ile giriş yap
            </button>

            <div style={{ marginTop: 24, fontSize: 12, color: '#aaa' }}>
              Sadece yetkili kullanıcılar giriş yapabilir
            </div>
            <div style={{ marginTop: 16, fontSize: 12 }}>
              <a href="/gizlilik" style={{ color: '#888', textDecoration: 'underline' }}>
                Gizlilik Politikası
              </a>
            </div>
          </>
        )}

        {/* Adım: E-posta */}
        {adim === 'email' && (
          <form onSubmit={otpGonder}>
            <input
              type="email"
              placeholder="ornek@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoFocus
              style={{
                width: '100%', padding: '12px 14px', borderRadius: 8,
                border: '1px solid #ddd', fontSize: 14, outline: 'none',
                boxSizing: 'border-box', marginBottom: 12,
              }}
            />
            {hata && <div style={{ color: '#f5222d', fontSize: 13, marginBottom: 10 }}>{hata}</div>}
            <button
              type="submit"
              disabled={yukleniyor}
              style={{
                width: '100%', padding: '12px 20px', borderRadius: 8,
                border: 'none', background: '#534AB7', color: 'white',
                cursor: yukleniyor ? 'not-allowed' : 'pointer',
                fontSize: 14, fontWeight: 600, opacity: yukleniyor ? 0.7 : 1,
              }}
            >
              {yukleniyor ? 'Gönderiliyor...' : 'Kod gönder'}
            </button>
            <button
              type="button"
              onClick={() => { setAdim('secim'); setHata(''); }}
              style={{ marginTop: 12, background: 'none', border: 'none', color: '#888', fontSize: 13, cursor: 'pointer' }}
            >
              ← Geri
            </button>
          </form>
        )}

        {/* Adım: Kod girişi */}
        {adim === 'kod' && (
          <div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginBottom: 20 }}>
              {kod.map((k, i) => (
                <input
                  key={i}
                  ref={el => { kodRefs.current[i] = el; }}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={k}
                  onChange={e => kodGuncelle(i, e.target.value)}
                  onKeyDown={e => kodKeyDown(i, e)}
                  style={{
                    width: 44, height: 52, textAlign: 'center', fontSize: 24, fontWeight: 700,
                    border: `2px solid ${k ? '#534AB7' : '#ddd'}`, borderRadius: 8,
                    outline: 'none', background: k ? '#f0eeff' : 'white',
                  }}
                />
              ))}
            </div>

            {hata && <div style={{ color: '#f5222d', fontSize: 13, marginBottom: 10 }}>{hata}</div>}

            <button
              onClick={() => dogrula()}
              disabled={yukleniyor || kod.join('').length < 6}
              style={{
                width: '100%', padding: '12px 20px', borderRadius: 8,
                border: 'none', background: '#534AB7', color: 'white',
                cursor: (yukleniyor || kod.join('').length < 6) ? 'not-allowed' : 'pointer',
                fontSize: 14, fontWeight: 600, opacity: (yukleniyor || kod.join('').length < 6) ? 0.5 : 1,
                marginBottom: 12,
              }}
            >
              {yukleniyor ? 'Doğrulanıyor...' : 'Giriş yap'}
            </button>

            <button
              onClick={geriSayim > 0 ? undefined : otpGonder}
              disabled={geriSayim > 0}
              style={{
                background: 'none', border: 'none',
                color: geriSayim > 0 ? '#aaa' : '#534AB7',
                fontSize: 13, cursor: geriSayim > 0 ? 'default' : 'pointer',
              }}
            >
              {geriSayim > 0 ? `Tekrar gönder (${geriSayim}s)` : 'Kodu tekrar gönder'}
            </button>

            <div style={{ marginTop: 8 }}>
              <button
                onClick={() => { setAdim('email'); setKod(['', '', '', '', '', '']); setHata(''); }}
                style={{ background: 'none', border: 'none', color: '#888', fontSize: 13, cursor: 'pointer' }}
              >
                ← E-postayı değiştir
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
